import { Box } from '@mui/material';
import DocHead from 'components/DocHead/DocHead';
import { getPathname } from 'helpers';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import HeaderControls from '../HeaderControls/HeaderControls';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import MobileWarning from '../MobileWarning/MobileWarning';
import Progress from '../Progress/Progress';
import SettingsControls from '../SettingsControls/SettingsControls';

export default function Main({ children }: MainProps) {
    const router = useRouter();

    // Anonymous users never reach a /lessons/* route (ApiProvider redirects
    // them to landing before this tree mounts — #171), so any visitor who
    // does render this path is authenticated and gets the real game layout.
    const path = useMemo(() => getPathname(router.asPath), [router.asPath]);
    const wrap = useMemo(() => path.startsWith('/lessons/'), [path]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            <DocHead />
            <MobileWarning minWidth={800}>
                <Box
                    component="main"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        order: 2,
                        padding: wrap ? 3 : undefined,
                        position: 'relative',
                    }}
                >
                    {wrap ? (
                        <Box
                            tabIndex={-1}
                            sx={{
                                alignItems: 'flex-start',
                                display: 'flex',
                                flex: 1,
                                flexDirection: 'row-reverse',
                                position: 'relative',
                            }}
                        >
                            {children}
                        </Box>
                    ) : (
                        children
                    )}
                    {process.env.NEXT_PUBLIC_ADMIN && <SettingsControls />}
                </Box>
            </MobileWarning>
            <Header>
                <Progress />
                <HeaderControls />
            </Header>
            <Footer />
        </Box>
    );
}
